import { componentsScope } from "../../../../common/utils/logger.js";

export const sheetScope = componentsScope.scope("sheetV1");
